import React from "react";
import { Navbar } from "../components/Shared";

export default function RefundPolicy() {
  return (
    <div>
      <Navbar />
      <div className="mx-auto max-w-3xl px-4 py-10 prose prose-neutral">
        <h1 className="text-3xl font-bold mb-2">Refund Policy</h1>
        <p className="text-sm text-neutral-500 mb-8">Effective Date: March 14, 2026 &nbsp;|&nbsp; Vizcaya Labs LLC</p>

        <p>Because all food products on the PrepMate platform are prepared and supplied by independent vendors, refund decisions are handled on a case-by-case basis. PrepMate may facilitate communication and resolution between customers and vendors, but vendors are primarily responsible for the quality and accuracy of the products they provide.</p>

        <h2 className="text-xl font-semibold mt-8 mb-3">Eligible Refund Circumstances</h2>
        <p>Refund requests may be considered in the following situations:</p>
        <ul>
          <li><strong>Incorrect order:</strong> You received meals or items that differ materially from what you ordered.</li>
          <li><strong>Missing items:</strong> Items included in your order were not delivered or provided at pickup.</li>
          <li><strong>Significant quality issues:</strong> Food arrived in a condition that makes it unsafe or unusable (e.g., spoiled, damaged packaging, temperature abuse).</li>
        </ul>

        <p>Refund requests will generally not be approved for:</p>
        <ul>
          <li>Change of mind or personal preference after an order is placed</li>
          <li>Dissatisfaction with taste or flavor, absent a documented quality or safety issue</li>
          <li>Failure to review allergen or ingredient information prior to ordering</li>
          <li>Circumstances outside the vendor's reasonable control</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-3">How to Submit a Refund Request</h2>
        <p>Refund requests must be submitted within <strong>24 hours</strong> of receiving your order. To submit a request, contact us at <a href="mailto:support@prepmate.app" className="underline">support@prepmate.app</a> with the following information:</p>
        <ul>
          <li>Your order number or account email</li>
          <li>A description of the issue</li>
          <li>Photos of the items received, if applicable</li>
        </ul>
        <p>Requests submitted more than 24 hours after delivery or pickup may not be eligible for a refund.</p>

        <h2 className="text-xl font-semibold mt-8 mb-3">Refund Process</h2>
        <p>PrepMate will review your request and, where appropriate, contact the vendor on your behalf. If a refund is approved, it will be issued to the original payment method via Stripe. Refund processing times are determined by Stripe and your financial institution and typically take 5–10 business days to appear on your statement.</p>
        <p>PrepMate is not obligated to issue a refund in all circumstances and reserves the right to evaluate each request individually based on the information provided.</p>

        <h2 className="text-xl font-semibold mt-8 mb-3">Vendor Responsibility</h2>
        <p>Independent vendors on the PrepMate platform are responsible for the quality, safety, and accuracy of their food products. While PrepMate will make reasonable efforts to facilitate refund resolution, ultimate responsibility for product quality rests with the vendor. PrepMate's liability for any refund is limited to the amount paid for the specific order giving rise to the claim.</p>

        <h2 className="text-xl font-semibold mt-8 mb-3">Subscription Cancellations</h2>
        <p>Meal plan subscriptions may be canceled at any time through your account dashboard. Cancellation stops future billing but does not automatically entitle you to a refund for the current billing period. If you believe a charge was made in error after cancellation, please contact us at <a href="mailto:support@prepmate.app" className="underline">support@prepmate.app</a>.</p>

        <h2 className="text-xl font-semibold mt-8 mb-3">Contact</h2>
        <p>For refund inquiries, contact Vizcaya Labs LLC at <a href="mailto:support@prepmate.app" className="underline">support@prepmate.app</a>.</p>
      </div>
    </div>
  );
}
